import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";
import { IngresoPorServicio } from "../../../services/analisisFinanzas";
import { useEstadisticasNumericas } from "../../../hooks/estadisticasNumericas";
import { currencyFormat } from "../../../utils/numberUtils";
import EstadisticasBadges from "../../organisms/EstadisticasBadges";
import Pagination from "../../organisms/Pagination";
import { generatePage } from "../../../utils/tableUtils";

interface IngresosPorServicioTableProps {
  ingresosPorServicio: IngresoPorServicio[];
  isLoading: boolean;
  itemsPorPagina: number;
}

function IngresosPorServicioTable({
  ingresosPorServicio,
  isLoading,
  itemsPorPagina,
}: IngresosPorServicioTableProps) {
  const [activePageNumber, setActivePageNumber] = useState(1);
  const estadisticas = useEstadisticasNumericas(
    ingresosPorServicio,
    (item) => item.ingresos
  );

  const paginaActual = useMemo(
    () =>
      generatePage(
        ingresosPorServicio,
        activePageNumber,
        itemsPorPagina
      ) as IngresoPorServicio[],
    [ingresosPorServicio, activePageNumber, itemsPorPagina]
  );

  return (
    <>
      <EstadisticasBadges
        estadisticas={estadisticas}
        formatearValor={currencyFormat}
      />

      <Table responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Nombre</StyledColHeader>
            <StyledColHeader>Tipo servicio</StyledColHeader>
            <StyledColHeader>Ingresos</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {paginaActual.map((item) => (
            <tr key={item.idServicio}>
              <td>{item.nombre}</td>
              <td>{item.tipoServicio}</td>
              <td>{currencyFormat(item.ingresos)}</td>
            </tr>
          ))}
          {estadisticas && (
            <StyledSummaryRow>
              <td colSpan={2}>Total</td>
              <td>{currencyFormat(estadisticas.total)}</td>
            </StyledSummaryRow>
          )}
          {!isLoading && paginaActual.length === 0 && (
            <tr>
              <td colSpan={3}>
                No hay ingresos por servicio para el rango de fechas seleccionado.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        pageSize={itemsPorPagina}
        setActivePageNumber={setActivePageNumber}
        activePageNumber={activePageNumber}
        rows={ingresosPorServicio}
      />
    </>
  );
}

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledSummaryRow = styled("tr")`
  background-color: ${(props) => props.theme.colors.light};
  font-weight: 700;
`;

export default IngresosPorServicioTable;
